import { Box } from '@chakra-ui/react';

import { AccommodationConfigurationForm } from '@app/components/molecules/accommodation-configuration-form';
import { BestOffer } from '@app/components/organisms/best-offer';

export const BestOfferSticky = () => {
    return (
        <Box
            boxShadow={'md'}
            borderRadius={'md'}
            p={4}
            position={'sticky'}
            top={0}
            bg={'white'}
            zIndex={2}
        >
            <AccommodationConfigurationForm
                mb={4}
                direction={{ md: 'column', xl: 'row' }}
                withDynamicLayout
                maxW={'auto'}
            />
            <BestOffer />
        </Box>
    );
};
